import React from 'react';
import { useParams } from 'react-router-dom';
import BaseLayout from '@/components/layout/BaseLayout';
import { PDFWorkspace } from '../containers/PDFWorkspace';

export const PDFEditorPage: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();

  if (!projectId) {
    return (
      <BaseLayout fullHeight>
        <div className="flex flex-col h-full bg-background items-center justify-center">
          <p className="text-muted-foreground">No project selected</p>
        </div>
      </BaseLayout>
    );
  }

  return (
    <BaseLayout fullHeight>
      <div className="flex flex-col h-full bg-background">
        <PDFWorkspace projectId={parseInt(projectId)} />
      </div>
    </BaseLayout>
  );
};
